import React, { FC, ComponentProps, JSXElementConstructor } from "react";
import { ChipsWithImageContainer, ChipImage } from "./styled";

type Props<A extends keyof JSX.IntrinsicElements | JSXElementConstructor<any> = any> = ComponentProps<A> & {
  club?: boolean;
  image: string;
  label: string;
  as: A;
};

const ChipsWithImage: FC<Props> = ({ label, image, ...props }) => {
  return (
    <ChipsWithImageContainer {...props}>
      <ChipImage>
        <img alt={label} src={image} />
      </ChipImage>
      <h3>{label}</h3>
    </ChipsWithImageContainer>
  );
};

export default ChipsWithImage;
